import {bzApi, metaboApi, metagApi, rawDataApi, transApi} from '@/axios'

// 查询项目列表

function getApiNameByPlat(plat) {
    let apiName
    switch (plat) {
        case 'bz':
            apiName = bzApi;
            break;
        case 'trans':
            apiName = transApi;
            break;
        case 'metag':
            apiName = metagApi;
            break;
        case 'metabo':
            apiName = metaboApi;
            break;
        case 'rawData':
            apiName = rawDataApi;
            break;
    }
    return apiName

}

export function projectList(sendData, plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/project/page',
        method: 'post',
        data: sendData
    })
}

// 导出项目
export function projectExport(plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/project/export/all',
        method: 'get',
        responseType: "blob"
    })
}


// 释放原始数据
export function projectRelease(id, plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/project/verifyRawData/' + id,
        method: 'get',
    })
}

// 删除项目
export function projectDel(id, plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/project/' + id,
        method: 'delete'
    })
}

// 编辑项目信息（类型+备注）
export function projectEdit(data, plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/project',
        method: 'put',
        data: data
    })
}

export function projectCustomerEdit(data, plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/project/customer/remark',
        method: 'put',
        data: data
    })
}

// / 更改项目的用户
export function projectChangeUser(data, plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/project/editUsers',
        method: 'put',
        data: data
    })
}

// 最后10条
export function projectLast_10_trans(plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/project/last-10',
        method: 'get',
    })
}

// 获取渐变色
export function getGradientByColor(data, plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/tool/color/gradient',
        method: 'post',
        data: data
    })
}

export function analyzeItemListByProjects_trans(sendData, plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/analyze/analyzeItemListByProjects',
        method: 'post',
        data: sendData
    })
}

export function customerProjectsBySalesName_trans(sendData, plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/project/customer-projects-by-sales',
        method: 'post',
        data: sendData
    })
}

export function projectLivenessPage_trans(sendData, plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/project/projectLivenessPage',
        method: 'post',
        data: sendData
    })
}

export function customerLivenessPage_trans(sendData, plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/project/customerLivenessPage',
        method: 'post',
        data: sendData
    })
}
export function getProjectIdBySearch(projectId, plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/project/searchById/'+projectId,
        method: 'get',
    })
}

// 按项目号 / 合同号搜索项目：POST /project/search
// data: { projectId: '', contractNumber: '' }，两个参数都可作为搜索条件
export function searchProject(data, plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/project/search',
        method: 'post',
        data: data
    })
}

// 统一取出列表数据：兼容 res.data 为数组 / { data: [] } / { records: [] } 几种返回结构
export function pickRecords(res) {
    if (!res || (res.code && res.code !== 200)) return []
    const data = res.data
    if (Array.isArray(data)) return data
    if (data && Array.isArray(data.data)) return data.data
    if (data && Array.isArray(data.records)) return data.records
    return []
}
export function getAnalyzeInfoByProjectId(projectId, plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/analyze/getAnalyzeInfoListByProjectId/'+projectId,
        method: 'get',
    })
}

// 分页查询分析列表：POST /analyze/page
// data: { page: { current, size }, condition: { projectId, analyzeId, ... }, sorts: [] }
export function analyzePage(data, plat) {
    let apiName = getApiNameByPlat(plat)
    return apiName({
        url: '/analyze/page',
        method: 'post',
        data: data
    })
}
